import {
  benefitIcon1,
  benefitIcon2,
  benefitIcon3,
  benefitImage2,
  chromecast,
  disc02,
  discord,
  discordBlack,
  facebook,
  figma,
  file02,
  framer,
  homeSmile,
  instagram,
  notification2,
  notification3,
  notification4,
  notion,
  photoshop,
  plusSquare,
  protopie,
  raindrop,
  recording01,
  recording03,
  roadmap1,
  roadmap2,
  roadmap3,
  roadmap4,
  searchMd,
  slack,
  sliders04,
  telegram,
  twitter,
  yourlogo,
} from './asset';

export const navigation = [
  {
    id: '0',
    title: 'provider_page.navigation.calculator',
    url: '#calculator',
  },
  {
    id: '1',
    title: 'provider_page.navigation.withdrawal',
    url: '#earning-manage',
  },
  {
    id: '2',
    title: 'provider_page.navigation.protection',
    url: '#protection',
  },
  {
    id: '3',
    title: 'provider_page.navigation.services',
    url: '#how-to-use',
  },
  {
    id: '4',
    title: 'provider_page.navigation.community',
    url: '#community',
  },
  {
    id: '5',
    title: 'header.menu.deploy',
    url: 'https://cloud.crowdcomputed.com/',
    external: true,
  },
];

export const heroIcons = [homeSmile, file02, searchMd, plusSquare];

export const notificationImages = [notification4, notification3, notification2];

export const companyLogos = [yourlogo, yourlogo, yourlogo, yourlogo, yourlogo];

export const brainwaveServices = [
  'provider_page.gpu_utility.client_benefits.easy_setup',
  'provider_page.gpu_utility.client_benefits.real_time_monitoring',
  'provider_page.gpu_utility.client_benefits.flexible_tasks',
  'provider_page.gpu_utility.client_benefits.privacy_security',
];

export const brainwaveServicesIcons = [recording03, recording01, disc02, chromecast, sliders04];

export const roadmap = [
  {
    id: '0',
    title: 'Voice recognition',
    text: 'Enable the chatbot to understand and respond to voice commands, making it easier for users to interact with the app hands-free.',
    date: 'May 2023',
    status: 'done',
    imageUrl: roadmap1,
    colorful: true,
  },
  {
    id: '1',
    title: 'Gamification',
    text: 'Add game-like elements, such as badges or leaderboards, to incentivize users to engage with the chatbot more frequently.',
    date: 'May 2023',
    status: 'progress',
    imageUrl: roadmap2,
  },
  {
    id: '2',
    title: 'Chatbot customization',
    text: "Allow users to customize the chatbot's appearance and behavior, making it more engaging and fun to interact with.",
    date: 'May 2023',
    status: 'done',
    imageUrl: roadmap3,
  },
  {
    id: '3',
    title: 'Integration with APIs',
    text: 'Allow the chatbot to access external data sources, such as weather APIs or news APIs, to provide more relevant recommendations.',
    date: 'May 2023',
    status: 'progress',
    imageUrl: roadmap4,
  },
];

export const collabText =
  "With smart automation and top-notch security, it's the perfect solution for teams looking to work smarter.";

export const collabContent = [
  {
    id: '0',
    title: 'Seamless Integration',
    text: collabText,
  },
  {
    id: '1',
    title: 'Smart Automation',
  },
  {
    id: '2',
    title: 'Top-notch Security',
  },
];

export const collabApps = [
  {
    id: '0',
    title: 'Figma',
    icon: figma,
    width: 26,
    height: 36,
  },
  {
    id: '1',
    title: 'Notion',
    icon: notion,
    width: 34,
    height: 36,
  },
  {
    id: '2',
    title: 'Discord',
    icon: discord,
    width: 36,
    height: 28,
  },
  {
    id: '3',
    title: 'Slack',
    icon: slack,
    width: 34,
    height: 35,
  },
  {
    id: '4',
    title: 'Photoshop',
    icon: photoshop,
    width: 34,
    height: 34,
  },
  {
    id: '5',
    title: 'Protopie',
    icon: protopie,
    width: 34,
    height: 34,
  },
  {
    id: '6',
    title: 'Framer',
    icon: framer,
    width: 26,
    height: 34,
  },
  {
    id: '7',
    title: 'Raindrop',
    icon: raindrop,
    width: 38,
    height: 32,
  },
];

export const pricing = [
  {
    id: '0',
    title: 'provider_page.earning_tiers.low_tier.title',
    price: 'provider_page.earning_tiers.low_tier.earnings',
    features: [
      'provider_page.earning_tiers.low_tier.gpu',
      'provider_page.earning_tiers.low_tier.memory',
      'provider_page.earning_tiers.low_tier.duration',
      'provider_page.earning_tiers.low_tier.storage',
    ],
  },
  {
    id: '1',
    title: 'provider_page.earning_tiers.mid_tier.title',
    price: 'provider_page.earning_tiers.mid_tier.earnings',
    features: [
      'provider_page.earning_tiers.mid_tier.gpu',
      'provider_page.earning_tiers.mid_tier.memory',
      'provider_page.earning_tiers.mid_tier.duration',
      'provider_page.earning_tiers.mid_tier.storage',
    ],
  },
  {
    id: '2',
    title: 'provider_page.earning_tiers.high_tier.title',
    price: 'provider_page.earning_tiers.high_tier.earnings',
    features: [
      'provider_page.earning_tiers.high_tier.gpu',
      'provider_page.earning_tiers.high_tier.memory',
      'provider_page.earning_tiers.high_tier.duration',
      'provider_page.earning_tiers.high_tier.storage',
    ],
  },
];

export const benefits = [
  {
    id: '0',
    title: 'provider_page.earnings_features.optimization.title',
    text: 'provider_page.earnings_features.optimization.desc',
    backgroundUrl: '/images/benefits/card-1.svg',
    iconUrl: benefitIcon1,
    imageUrl: benefitImage2,
  },
  {
    id: '1',
    title: 'provider_page.earnings_features.transparency.title',
    text: 'provider_page.earnings_features.transparency.desc',
    backgroundUrl: '/images/benefits/card-2.svg',
    iconUrl: benefitIcon2,
    imageUrl: benefitImage2,
    light: true,
  },
  {
    id: '2',
    title: 'provider_page.earnings_features.scheduling.title',
    text: 'provider_page.earnings_features.scheduling.desc',
    backgroundUrl: '/images/benefits/card-3.svg',
    iconUrl: benefitIcon3,
    imageUrl: benefitImage2,
  },
];

export const socials = [
  {
    id: '0',
    title: 'Discord',
    iconUrl: discordBlack,
    url: '#',
  },
  {
    id: '1',
    title: 'Twitter',
    iconUrl: twitter,
    url: '#',
  },
  {
    id: '2',
    title: 'Instagram',
    iconUrl: instagram,
    url: '#',
  },
  {
    id: '3',
    title: 'Telegram',
    iconUrl: telegram,
    url: '#',
  },
  {
    id: '4',
    title: 'Facebook',
    iconUrl: facebook,
    url: '#',
  },
];
